var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHatchedLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.36707 24L3.29482 21.0953L9.14405 13.6883L0 10.9652L1.55486 6.28139L10.5508 9.40393L10.3287 0H15.3635L15.1414 9.40393L24.1003 6.28139L25.6552 10.9652L16.5481 13.6883L22.3233 21.0953L18.2511 24L12.8461 16.3026L7.36707 24Z",
    fill: "#1540D7"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHatchedLogo);
export default __webpack_public_path__ + "static/media/hatchedLogo.70686c4adda5bfc48b0867b6ac0183a0.svg";
export { ForwardRef as ReactComponent };